<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>群组控制</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">表单</span>
      <el-form ref="form"
               :model="dataModel"
               :rules="formRules"
               size="medium"
               label-width="140px">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item prop="name" label="群组批次描述">
              <el-input v-model="dataModel.name"></el-input>
            </el-form-item>
            <el-form-item label="客户名称/编号"
                          prop="customerid">
              <remote-select
                v-model="dataModel.customerid"
                id-key="number"
                label-key="name"
                value-key="id"
                :query-request="getCustomerTable"
                :find-request="getCustomerDetail"
                clearable
                :disabled="!!dataModel.id" />
            </el-form-item>
            <el-form-item label="项目名称/编号"
                          prop="projectid">
              <remote-select
                id-key="number"
                label-key="name"
                value-key="id"
                placeholder="请输入项目名称/编号搜索"
                v-model="dataModel.projectid"
                @change="onChangeProjectId"
                :disabled="!dataModel.customerid || Boolean(dataModel.id)"
                :query-request="getBaiscProjectTable"
                :query-params="{customerid: dataModel.customerid}"
                :find-request="getProjectDetail"
                clearable>
              </remote-select>
            </el-form-item>

            <el-form-item prop="batchid"
                          label="批次名称/编号">
              <remote-select
                class="width-max"
                clearable
                id-key="number"
                label-key="detail"
                value-key="id"
                :multiple="true"
                placeholder="请输入批次关键字"
                v-model="dataModel.batchid"
                :disabled="!dataModel.projectid"
                :query-request="(_)=>getBatchTable(Object.assign({customerid: dataModel.customerid, projectid:dataModel.projectid, per_page: 100}, _))"
                :find-request="getBatchDetail">
              </remote-select>
            </el-form-item>

            <el-form-item label="管理员" prop="platform_admin_ids">
              <el-col>
                <remote-select
                  class="width-max"
                  clearable
                  multiple
                  :multiple-limit="5"
                  id-key="id"
                  label-key="name"
                  keyword-key="name"
                  value-key="id"
                  placeholder="请输入管理员"
                  v-model="dataModel.platform_admin_ids"
                  :query-request="(_)=>getBasicPlatformUsersIndex(Object.assign({customerid: dataModel.customerid}, _))"
                  :find-request="getPlatformUsersDetail">
                </remote-select>
              </el-col>
            </el-form-item>
            <el-form-item label="群组类型" prop="group_type">
              <el-radio-group v-model="dataModel.group_type" :disabled="!!dataModel.id">
                <el-radio :label="2">按项目</el-radio>
                <el-radio :label="1">按客户</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </div>
        <el-form-item>
          <el-button
            @click="onCancel">取消
          </el-button>
          <el-button type="primary"
                     @click="onSubmit">保存
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
export default {
  data () {
    return {
      id: null,
      inputWith: 12,
      formRules: {
        name: [
          {required: true, message: '群组批次描述不能为空', trigger: 'blur'},
        ],
        batchid: [
          {required: true, message: '批次编号不能为空', trigger: 'blur'},
        ],
        customerid: [
          {required: true, message: '客户编号不能为空', trigger: 'blur'},
        ],
        projectid: [
          {required: true, message: '项目编号不能为空', trigger: 'blur'},
        ],
        group_type: [
          {required: true, message: '请选择群组类型', trigger: 'change'},
        ],
      },
      dataModel: {
        id: '',
        customerid: '',
        projectid: '',
        batchid: '',
        name: '',
        platform_admin_ids: '',
        group_type: 1,
        tenant_customerid: this.$route.params.tenant_customerid
      },
      inLoading: {
        customerid: false,
        projectid: false,
        batchid: false,
      },
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },

  created () {
  },

  methods: {
    ...request.map([
      'getBatchTable',
      'getBatchDetail',
      'getCustomerTable',
      'getCustomerDetail',
      'getBaiscProjectTable',
      'getProjectDetail',
      'getBasicPlatformUsersIndex',
      'getPlatformUsersDetail'
    ]),
    onLoad () {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data())
      this.onLoad()
    },
    setForm (id) {
      request.page('getGroupBatchDetail', {id}).then(({data}) => {
        data.customerid += ''
        data.group_type = Number(data.group_type || 1)
        filter.setLoop(this.dataModel, data)
      })
    },
    onChangeProjectId () {
      this.dataModel.batchid = ''
    },

    onSubmit () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.$message.error('提交内容填写不正确！')
          return
        }

        const submitApi = this.$route.params.id ? 'updateGroupBatchData' : 'createGroupBatchData'

        const submitModel = {
          ...this.dataModel,
        }
        if (this.$route.params.id) {
          submitModel.id = this.$route.params.id
        } else {
          // 默认开启差值限制
          submitModel.redundant_taskcnt_restrict = 1
        }

        request.common(submitApi, submitModel).then((res) => {
          this.$router.go(-1)
        })
      })
    },
    onCancel () {
      this.$router.go(-1)
    },
    unionBy: _.unionBy,
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/group-batch/pages/GroupBatchForm.vue